import { NAME_PATTERN } from '../constants';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { FormBuilder, FormGroup , FormControl, Validators } from '@angular/forms';
import { payerData } from '../../../@core/interfaces/patient-services/payer';
import { DatePipe, Location } from '@angular/common';
import * as gender from '../../../data/gender.json';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { environment } from '../../../../environments/environment';
//import { Checkout } from 'capacitor-razorpay';
import { PaymentGatewayService } from '../../../_services/paymentservice.service';
import { access } from 'fs';
import { NbDateService, NbDialogService, NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { OtpVerifyDialogComponent } from '../otp-verify-dialog/otp-verify-dialog.component';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { NbAuthResult, NbAuthService } from '@nebular/auth';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { INgxSelectOption } from 'ngx-select-ex';
import * as title from './../../../data/title.json';
import { UserData } from '../../../@core/interfaces/common/users';
import { HttpClient } from '@angular/common/http';
declare var Razorpay: any;
import * as countryCodeLists from './../../../data/countryCode.json';
import { error } from 'console';
import { ToastrAppSrvcService } from '../../../_services/toastr-app-srvc.service';
import { WhatsappIntegration } from '../../../@core/interfaces/common/whatsappIntegration';
import { ReferralData } from '../../../@core/interfaces/masters/referral';
import { MailIntegration } from '../../../@core/interfaces/common/mailIntegration';
import { CountryService } from '../../../_services/patient-portal-country.service';
import { PGOrderDetDto } from '../../../@core/interfaces/common/paymentgateway';


@Component({
  selector: 'ngx-booking-summary-login',
  templateUrl: './booking-summary-login.component.html',
  styleUrls: ['./booking-summary-login.component.scss']
})
export class BookingSummaryLoginComponent implements OnInit {
  titleList: any = (title as any).default;
  user: any;
  errors: any[];
  messages: any[];
  submitted: boolean;
  loginResult: any={};
  doctorId:string;
  docDetail:any = {};
  slotDate:any;
  slotTime:any;
  bookingPlatFormApp:FormGroup;
  clinicType:string;
  duration:any;
  isAppointmentSaved:boolean=false;
  placeholder:string='Select';
  genderList: string[]= (gender as any).default;
  loginForm:FormGroup;
  openLoginPopup:boolean=false;
  openForgotPopUpflag:boolean=false;
  mobileVerifyPopUp:boolean=false;
  loginData:any;
  resetPasswordForm:FormGroup;
  otpForm:FormGroup;
  isSubmitted:boolean=false;
  userAlreadyExists:boolean=false;
  patientLists:Array<any>=[];
  userList:Array<any>=[];
  loginUserAuthorized:boolean=false;
  protected readonly unsubscribe$ = new Subject<void>();
  invalidbookingPlatFormAppForm:boolean=false;
  registerPatientButtonMessage:string="Continue";
  updated: boolean=false;
  get apiUrl(): string {
    return environment.apiUrl;
  }
  loginPatient:any={};
  loginFlag:boolean=false;
  
  signUp:boolean=false;
  det: { DoctorId: string; Date: string; Duration: string; PatientName: string; PatientGender: string; PatientMobileNo: string; patientDOB: string; Type: string; regId: string; inputJson:string,CreatedBy:number,vaccineId:number,tenantId:string,branchId:string,departmentId:string};
  phoneNumber: number;
  OTPid:string;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  // Surfaces the backend's specific message (rate-limit/cooldown text on send failures, or the
  // verify failure reason) instead of the hardcoded "Incorrect OTP" for every case. Reused for
  // both getotpsms() and onVerify() since the popup is already open by the time either fires.
  otpErrorMessage: string = 'Incorrect OTP';
  lastFourDigits:string;
  maxDobDate: Date;
  vaccineFlag:boolean=false;
  vaccineDetail:any={};
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  @ViewChild("tabSetRef") tabsetEl: NbTabsetComponent;
  @ViewChild("tabLogin") login: NbTabComponent;
  @ViewChild("registerTab") register: NbTabComponent;

  isPasswordMatch:boolean=false;
  showPassword:boolean = false;
  smscontent:string;
  sendthroughsms:boolean=false;
  isOtpDia: boolean =false;
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  passwordExists:boolean=false;
  passwordWeak:boolean=false;
  // Mirrors the server-side PasswordPolicy: min 8 chars with upper, lower, number and special.
  readonly strongPasswordPattern: RegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])(?=.{8,})/;
  
  fees:number;
  orderiddetails:Array<any>=[];
  username:string;
  mobilenum:string;
  orderid:string;
  payment='notpaid';
  templateData:Array<any>=[];
  regId:string;
  accessToken:string;
  patientDetails:Array<any>=[];
  password:string;
  rePassword:string;
  loginPassword:string;
  show:boolean = false;
  show2:boolean = false;
  show3:boolean = false;
  isNewPasswordEntered:boolean=false;
  isNewRePasswordEntered:boolean=false;
  isLoginPasswordEntered:boolean=false;

  fromPortalForEdit:string='fromPortalEdit';
  fromPortal:string='fromPortal';
  customer:boolean=true;
  tenatId = environment.patientTenantId;
  cusId = environment.patientCusID;
  branchId=environment.patientBranchId
  hospitalDetail:any={};
  countryCodeDropDownLists: Array<any>=[];
  mobileMinlength: number;
  mobileMaxlength: number;
  imageLinkList:Array<any>=[];
  @Input() docId:string;
  @Input() selectedDate:Date;
  @Input() selectedSlot:string;
  @Input() visitType:string;
  @Input() timeDuration:any;
  @Output() changeTime = new EventEmitter<void>();
  @Input() avgFeedback:number;
  @Input() stars:string[];
  @Input() feedbackCount:number;
  @Input() bookingPath:string;
  @Input() docFee:number;
  countryName:string;
  nearByCity:string;
  nearByRegion:string;
  countryCode:string = localStorage.getItem('countryCode');

  userName:string='Nandhini';
  userMobileNumber:string='6385299769';
  selectedCC:string='';
  whatsappcontent: string;
  whatsAppToken:string=''
  whatsAppUrl:string=''
  dialogRef: any = null;
  @ViewChild('whatsappDialog') whatsappDialog: TemplateRef<any>;
  towhatsappnumber: string;
  pageName:string = 'registration';
  patRegId:string = '';
  superAdminTenant:any={};
  emailcontent:string;
  patientEmail:string;
  lastCountryCode: string | null = null;
  tabTitle:string='signIn';

  constructor(private datePipe: DatePipe, protected cd: ChangeDetectorRef,public router: Router,public DatService:DateService,protected dateService: NbDateService<Date>,private api:PaymentGatewayService,protected rolesService: RolesData,private route: ActivatedRoute,private getDrAppointmentService: PatientAppointmentData , private fb:FormBuilder , private phySrvc : payerData,private patSrvc: PatientRegistrationData, protected initUserService: InitUserService,protected service: NbAuthService,protected userService: UserData,private http:HttpClient,
    public location : Location,private patAptSrv: PatientAppointmentData, private countryService: CountryService,
  private pyrSrvc: payerData,private toaster: ToastrAppSrvcService,protected whatsappService : WhatsappIntegration,protected dialogService: NbDialogService,protected referralService:ReferralData,protected MailService : MailIntegration) { 
    this.bookingPlatFormApp = this.fb.group({
      mobile: this.fb.control(null,[Validators.required,Validators.maxLength(20),Validators.minLength(10)]),
      firstName: this.fb.control(null,[Validators.required,Validators.pattern(NAME_PATTERN)]),
      lastName: this.fb.control(null,[Validators.pattern(NAME_PATTERN)]),
      dob: this.fb.control(null,[Validators.required]),
      gender:this.fb.control(null,[Validators.required]),
      title:this.fb.control(null,[Validators.required]),
       pass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$')]),
      confirmPass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$')]),
      mobileCountryCode: this.fb.control('',[Validators.required]),
      email: this.fb.control(null, [ Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)])
    });
    this.loginForm = this.fb.group({
      fullName: this.fb.control(null,[Validators.pattern('^[0-9]+$'), Validators.maxLength(20), Validators.minLength(10)]),
      password: this.fb.control(null),
      tenantId: this.fb.control(''),
      branchId: this.fb.control(''),
      rememberMe: this.fb.control(''),
      mobileCountryCode: this.fb.control('',[Validators.required])
    });
    this.resetPasswordForm=this.fb.group({
      resetMobile: this.fb.control(null,[Validators.required,Validators.pattern('^[0-9]+$'), Validators.maxLength(20), Validators.minLength(10)]),
      resetNewPassword: this.fb.control(null),
      reEnterNewPassword: this.fb.control(null)
    });
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  }
  get fval() { return this.bookingPlatFormApp.controls; }
  get fval2() { return this.otpForm.controls; }
  get fval3() {return this.loginForm.controls;}
  get fval4() {return this.resetPasswordForm.controls;}

  ngOnInit(): void {
    this.maxDobDate = this.dateService.addDay(this.dateService.today(), 0);
    this.password = 'password';
    this.rePassword = 'password';
    this.hospitalDetail = JSON.parse(localStorage?.getItem('docDet'));
    // this.start();
    this.loadAllDoctorImages();
    this.loadCountryMaster();

    this.countryService.countryCode$.pipe(distinctUntilChanged()).subscribe(code => {
      if (this.lastCountryCode !== code) {
        this.lastCountryCode = code;
        this.countryCode = code;
      }
    });
  }

  ngOnChanges(){
    this.doctorId = this.docId;
    this.slotDate = this.selectedDate;
    this.slotTime = this.selectedSlot;
    this.clinicType = this.visitType;
    this.duration = this.timeDuration;
  }

  onTabChange(event){
    if (event.tabTitle == 'Sign Up') {
      this.loadCountryMaster();
      this.tabTitle='signUp'
    }else this.tabTitle='signIn'
  }

  loadAllDoctorImages(){
    this.rolesService.list("ImageAtchDet/" + environment.patientTenantId +'/null/all'+'?countryCode='+this.countryCode).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.imageLinkList = data;

    }, (error) => {
      this.loadDoctorDetail();
    }, () => {
      this.loadDoctorDetail();
    }); 
  }

  loadDoctorDetail(){
    let det={
      doctorId:this.doctorId,
      countryCode:this.countryCode
    }
    this.getDrAppointmentService.searchList(`bookingPlatform/getDrInfo`, det).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      this.docDetail = data;
      if (this.docDetail){
        const downloadData = this.imageLinkList.find(img => img.phyId === this.docDetail.doctorId)?.imageLink || '';
        if(downloadData) this.docDetail.imageLink = 'data:image/jpeg;base64,' + downloadData;
        else this.docDetail.imageLink = '';
      }
    }, (error) => {
    }, () => {
    });
  } 


   loginCreate(): void {
    this.submitted=true;
    this.loginForm.controls["tenantId"].setValue(environment.virtualTenant.toLowerCase());
    this.loginForm.controls["branchId"].setValue(environment.virtualBranch.toLowerCase());  
    this.user = this.loginForm.value;  
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    const auth ={
      "fullName": "9500672785",
      "password": "Ezovion@1",
      "rememberMe": "",
      "tenantId": "6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4",
      "branchId": "4e54f59e-226b-42a3-8ef2-cda3ac8fc727"
  }
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((data)=> {      

    //   const det = data
    // })
    this.service.authenticate("email", this.user).subscribe((result: NbAuthResult) =>
    {  
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((result)=> {
      this.submitted = false;
      this.loginResult =result;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.initUserService.initCurrentUser().subscribe();
        this.userAlreadyExists = false;
        var searchData={
          "searchWord": this.user.fullName,
          "fromDate": null,
          "toDate": null,
          "skip": 0,
          "take": 100
      };
        this.patSrvc.searchList("patientregistrationmst/" + environment.virtualTenant + '/' + environment.virtualBranch + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {    
          this.loginPatient = data[0];
          var regID=data[0]?.id;
              var firstName=data[0]?.firstname;
              localStorage.setItem("loginuser","patientlogin");
              localStorage.setItem("regID",regID);
              localStorage.setItem("patientMobNo",this.user.fullName);
              localStorage.setItem("patientName",firstName);
              localStorage.setItem("patientCountryCode", data[0].country);
              if(data[0]?.email){
                localStorage.setItem('patientEmail', data[0]?.email);
              }
              this.isSubmitted=false;
              localStorage.setItem("countryCode",this.countryCode);
              return this.router.navigate(['pages/patient-portal/confirm-booking',this.doctorId,this.slotDate,this.slotTime ,this.clinicType, this.duration, this.feedbackCount,this.avgFeedback, this.bookingPath, this.docFee]);
          });
      } else {
      
        // this.router.navigate(['auth/patient-portal']);
        if(result.getResponse().status == 403)
        this.errors.push("Your account has been disabled, Please see your administrator");
        else
        this.errors.push("Incorrect credentials. Try again.");
        return this.router.navigate(['/auth/patient-portal']);
      }


      this.cd.detectChanges();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    this.checkIsExists(event);
    return true;

  }

  checkIsExists(event){


if(event.target.value.length >= 10){
  let data={
    "PatientMobile":event.target.value,
    "countryId":(this.tabTitle==='signIn') ? this.loginForm.get('mobileCountryCode')?.value : this.bookingPlatFormApp.get('mobileCountryCode')?.value
  }
  event.target.disabled = true;
  this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
   
    this.patientLists = [];
    this.userList = [];
    
    // Check if the patient alone exists
    if (returnData.patient.length !== 0 && returnData.user == null) {
      this.patientDetails = returnData?.patient;
      this.bookingPlatFormApp.controls['firstName']?.setValue(this.patientDetails[0]?.firstname);
      this.bookingPlatFormApp.controls['lastName']?.setValue(this.patientDetails[0]?.lastname);
      this.bookingPlatFormApp.controls['dob']?.setValue(this.patientDetails[0]?.dob);
      this.bookingPlatFormApp.controls['gender']?.setValue(this.patientDetails[0]?.gender);
      this.bookingPlatFormApp.controls['mobile']?.setValue(this.patientDetails[0]?.mobile);

      this.userAlreadyExists = false;
    }
    // Check if both patient and user exist
    else if (!!returnData.patient && returnData.user != null) {
      if(this.tabTitle!=='signIn') this.userAlreadyExists = true;
      this.openLoginPopup = true;

      if (this.openLoginPopup) {
        this.tabsetEl.selectTab(this.login);
      }
      this.loginForm.get('fullName').setValue(event.target.value);
      this.patientLists = returnData.patient;
      this.userList = returnData.user;
    } 
    //when neither patient nor user exist
    else {
      this.userAlreadyExists = false;
      this.openLoginPopup = false;
      this.customer = false;

      if(this.tabTitle==='signIn'){
        this.toaster.ForDanger('No account found with this mobile number. Please sign up to continue.');
      }
    }}, (error) => {
  }, () => {
    event.target.disabled = false;
  });
}

  }

  openForgotPopUp(){
    this.openForgotPopUpflag = true;
    var mbl = this.loginForm.get('fullName').value;
    if(mbl){
      this.resetPasswordForm.get('resetMobile').setValue(mbl);
    }
  }


  closeAppointmentSuccessPopup(){
    this.router.navigate(['/auth/patient-portal-appointment-booking']);
  }

  focustoOpenSelect($event){ 
    $event.optionsOpen()
  }
  tabToClose($event){
    $event.optionsClose()
  }

  onTitleChange(event: INgxSelectOption[]) {
    if (event[0].data.value == "1" || event[0].data.value == "5") {
      this.bookingPlatFormApp.controls['gender'].setValue("Male");
    }
    else if (event[0].data.value == "2" || event[0].data.value == "3" || event[0].data.value == "4") {
      this.bookingPlatFormApp.controls['gender'].setValue("Female");
    }
  }

       saveAppBookingReg(fromLogin?){
  
          if(this.bookingPlatFormApp.valid && this.bookingPlatFormApp?.get('pass')?.value === this.bookingPlatFormApp?.get('confirmPass')?.value || !!fromLogin){
            this.isSubmitted=true;
            let newData=new Date( this.bookingPlatFormApp.get('dob').value);
            const today = new Date();
        
            var Difference_In_Time = Math.abs(Date.now() - newData.getTime());
            var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
            var ageValue = Difference_In_Days / 365.25;
            const year = (Math.round(ageValue));
            const fullname=this.bookingPlatFormApp.get('firstName').value+(this.bookingPlatFormApp.get('lastName').value ?''+this.bookingPlatFormApp.get('lastName').value:'');
            const selectedCC = this.countryCodeDropDownLists.find(c => c.id === this.bookingPlatFormApp.get('mobileCountryCode')?.value)?.countryCode;
            let requestData ={
                branchId: environment.virtualBranch,
                email: this.bookingPlatFormApp.get('email').value,
                fName:  this.bookingPlatFormApp.get('firstName').value,
                lName: null,
                mobileNum: this.bookingPlatFormApp.get('mobile').value,
                tenantId: environment.virtualTenantID,
                fullName: fullname,
                userFlag: "Patient",
                title: this.bookingPlatFormApp.get('title').value,
                gender: this.bookingPlatFormApp.get('gender').value,
                age: year,
                loginUserType: "patientlogin",
                password: this.bookingPlatFormApp.get('pass').value,
                confirmPassword: this.bookingPlatFormApp.get('confirmPass').value,
                CountryId:this.bookingPlatFormApp.get('mobileCountryCode')?.value,
                mobileCountryCode: selectedCC,
              }
              this.http.post(environment.apiUrl+'/auth/sign-upForMobile',requestData).subscribe((res) => {
                this.isAppointmentSaved=true; 
                this.signUp=false;    
                setTimeout(()=>{ this.isAppointmentSaved=false;},4000);
                this.tabsetEl.selectTab(this.login);
                this.loginForm.get('fullName').setValue(requestData.mobileNum);
                this.loginForm.get('password').setValue(requestData.password);
                this.loginForm.get('mobileCountryCode')?.setValue(requestData.CountryId);
            },(error)=>{
              if(error.status==401){
              this.router.navigateByUrl('/auth/patient-portal');
            }
            },()=>{
              if(requestData?.email) this.patientEmail = requestData?.email;
              this.checksmspossibility("confirmation")
            })
          }
          else{
            this.invalidbookingPlatFormAppForm=true;
          }
       
         
        }

   saveAppBooking(fromLogin?) {
    if (this.bookingPlatFormApp.valid || !!fromLogin) {
      this.isSubmitted = true;
      
      const vaccine={
        "vaccineId": this.vaccineDetail?.id,
        "planned_Date": "2025-06-28T00:00:00.000Z",
        "done_Date": null,
        "notes": null,
        "visitId": 0,
        "regId": this.loginPatient?.id,
        "isPastVaccine": false,
        "performingDoctor": null,
        "performingNurse": null,
        "patientportal": true,
        "name": this.vaccineDetail?.name,
        "tenantId":this.hospitalDetail?.tenandId,
        "branchId":this.hospitalDetail.branchId,
        "departmentId":this.hospitalDetail.departmentId
      }
      //e.Firstname + e.Middlename != "" ? " " + e.Middlename : "" +e.Lastname != "" ? " " + e.Lastname : ""
      var patdet = this.loginPatient;
     
      this.det = {
            DoctorId: this.doctorId,
            Date: this.slotDate,
            Duration: this.duration,
            PatientName:(patdet?.firstname+(patdet?.middlename ? ' ' + patdet?.middlename : '') + (patdet?.lastname ? ' ' + patdet?.lastname : '')),
            PatientGender: patdet?.gender ,
            PatientMobileNo: patdet?.mobile,
            patientDOB: patdet?.dob,
            Type: this.clinicType,
            regId: (this.vaccineFlag?null: patdet?.id),
            inputJson:this.vaccineFlag?JSON.stringify(vaccine):null,
            CreatedBy:parseInt(localStorage.getItem("userId")),
            vaccineId:this.vaccineFlag?this.vaccineDetail?.id:null,
            tenantId:this.hospitalDetail?.tenandId,
            branchId:this.hospitalDetail.branchId,
            departmentId:this.hospitalDetail.departmentId
          }

     const url = this.vaccineFlag?'bookPatientAppointmentVaccine':"bookPatientAppointment"
      this.phySrvc.create(`bookingPlatform/${url}`,this.det).pipe(takeUntil(this.unsubscribe$)).subscribe(appDet => {

        this.router.navigate(['/pages/patient-portal/appointment-list'], {
          queryParams: { payment: true }
        });

      }, (error) => {
        this.isAppointmentSaved = false;
        this.isSubmitted = false;
      }, () => {
        this.isAppointmentSaved = true;
        this.isSubmitted = false;
      });

    }
    else {
      this.invalidbookingPlatFormAppForm = true;
    }


  }

  verifyMobileIsexist()
  {
    if(!!this.resetPasswordForm.get('resetNewPassword').value && !!this.resetPasswordForm.get('reEnterNewPassword').value){
      this.passwordExists = false;
      if(this.resetPasswordForm.get('resetNewPassword').value === this.resetPasswordForm.get('reEnterNewPassword').value){
        this.isPasswordMatch = false;
        if(!this.strongPasswordPattern.test(this.resetPasswordForm.get('resetNewPassword').value)){
          this.passwordWeak = true;
          return;
        }
        this.passwordWeak = false;
        // this.errors = [];
        this.otpForm.reset({
          digit1: '',
          digit2: '',
          digit3: '',
          digit4: '',
          digit5: '',
          digit6: '',
        });
        this.mobileVerifyPopUp=true;
        this.phoneNumber = this.resetPasswordForm.get('resetMobile').value;
        this.lastFourDigits = this.phoneNumber.toString().slice(-4);
        if(!!this.phoneNumber && this.phoneNumber!=undefined){
          this.userService.getBranchList(`patient-portal/${this.tenatId}/${this.branchId}/${this.phoneNumber}/getCurrentUserData`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            if(!!data){
              this.getotpsms();
            }
          })
       
        
        };
      }
      else{
        this.isPasswordMatch = true;
      }
    }
    else{
      this.passwordExists = true;
    }
    }

    getotpsms(){
      let data = {
        "headers": {
          "Accept": "application/vnd.ezovion.hateoas+json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      }
      // SECURITY: the backend no longer returns the OTP value, only { success, message }.
      // Verification of the user-entered code happens entirely server-side (see onVerify()).
      this.isFailure = false;
      this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenatId}/sendotp/${this.phoneNumber}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
      // Non-secret marker only - indicates an OTP has been sent, never the OTP value itself.
      this.OTPid = response && response.success ? 'sent' : null;
      }, (error) => {
      // Send failed (e.g. rate-limit/cooldown 429) - the popup is already open at this point
      // (mobileVerifyPopUp is set before getotpsms() is called), so surface it in the same
      // failure banner used for verify failures.
      this.otpErrorMessage = (error && error.error && error.error.message) || 'Unable to send OTP. Please try again.';
      this.isFailure = true;
      }, () => {
      });
    }

  enterPassword(){
    if(!!this.resetPasswordForm.get('resetNewPassword').value){
      this.isNewPasswordEntered = true;
    }
    else{
      this.isNewPasswordEntered = false;
      this.password = 'password';
      this.show = false;
    }
  }

  enterRePassword(){
    if(!!this.resetPasswordForm.get('reEnterNewPassword').value){
      this.isNewRePasswordEntered = true;
    }
    else{
      this.isNewRePasswordEntered = false;
      this.rePassword = 'password';
      this.show2 = false;
    }
  }

  enterLoginPassword(){
    if(!!this.loginForm.get('password').value){
      this.isLoginPasswordEntered = true;
    }
    else{
      this.isLoginPasswordEntered = false;
      this.loginPassword = 'password';
      this.show3 = false;
    }
  }

  togglePassword(){
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  togglerePassword(){
    if (this.rePassword === 'password') {
      this.rePassword = 'text';
      this.show2 = true;
    } else {
      this.rePassword = 'password';
      this.show2 = false;
    }
  }

  toggleLoginPassword(){
    if (this.loginPassword === 'password') {
      this.loginPassword = 'text';
      this.show3 = true;
    } else {
      this.loginPassword = 'password';
      this.show3 = false;
    }
  }

    onVerify() {

      let otp = "";
      otp += this.otpForm.get('digit1').value;
      otp += this.otpForm.get('digit2').value;
      otp += this.otpForm.get('digit3').value;
      otp += this.otpForm.get('digit4').value;
      otp += this.otpForm.get('digit5').value;
      otp += this.otpForm.get('digit6').value;
      if (otp != "") {
        // SECURITY: verification happens entirely server-side; the frontend never compares
        // the entered code against a locally-held OTP value.
        const verifyPayload = {
          otpCode: otp,
          userMobileNumber: this.phoneNumber
        };
        this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenatId}/verifyotp`, verifyPayload).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
          if (result && result.code === 200) {
            this.isSuccess = true;
            this.isFailure = false;
            this.mobileVerifyPopUp = false;
            this.openForgotPopUpflag = false;
            setTimeout(()=>{this.isSuccess = false;},3000)
            const det = {
              Password: this.resetPasswordForm.get('resetNewPassword').value,
              ConfirmPassword: this.resetPasswordForm.get('reEnterNewPassword').value,
              MobileNumber: this.phoneNumber
            }
            this.patSrvc.searchList('auth/updatePassword',det).pipe(takeUntil(this.unsubscribe$)).subscribe(()=>{
              this.resetPasswordForm.reset();
              this.updated = true;
              setTimeout(()=>{this.updated = false;},4000)
            }, (error) => {
              this.otpErrorMessage = (error && error.error && error.error.message) || 'Unable to update password. Please choose a stronger password and try again.';
              this.isFailure = true;
              this.isSuccess = false;
            })
            // this.diaClose.emit({ otpStatus: "approved" });
            // if (this.fromPage != "PatientPortal" && this.fromPage != "forgotPassword")
            //   this.sendsms();
          }
          else {
            this.otpErrorMessage = (result && result.status) || 'Incorrect OTP';
            this.isFailure = true;
            this.isSuccess = false;
          }
        }, (error) => {
          this.otpErrorMessage = (error && error.error && error.error.status) || 'Incorrect OTP';
          this.isFailure = true;
          this.isSuccess = false;
        });

      }
    }

    otpFormClose(){
      this.mobileVerifyPopUp=false; 
      this.otpForm.reset({
        digit1: '',
        digit2: '',
        digit3: '',
        digit4: '',
        digit5: '',
        digit6: '',
      });
    }

   
  getorderid() {
    let data:PGOrderDetDto = {
                            amount:this.fees,
                            currencyCode:"INR",
                            tenantId:environment.virtualTenant,
                            branchId:environment.virtualBranch,       
                            createdBy:parseInt(localStorage.getItem("userId")),
                            createdDate:this.DatService.currentDate()
                          }
    this.api.getOrderIdPayment(data,environment.virtualTenant,environment.virtualBranch).subscribe(async (data: any) => {
      this.orderiddetails = data;
      this.payWithRazor(data.order_id, data.currency, data.amount);
    }, async (err) => {
      this.saveAppBooking('fromLogin');
    })
  }

   payWithRazor(order_id, currency, amount) {
    let key ='rzp_test_RFmryJmgIzI0ps'
    this.phySrvc.list(`${this.apiUrl}/PaymentGatewayConfiguration/ActiveBranchPaymentGatewayConfig?tenantId=${environment.virtualTenantID}&branchId=${environment.virtualBranch}`).subscribe(data => {
      if(data?.detail){
        if(data?.detail?.liveModeState || data?.detail?.testModeState){
          if(data?.detail?.liveModeState && data?.detail?.liveApiId){
            key=data?.detail?.liveApiId
          }
          else if(data?.detail?.testModeState && data?.detail?.testApiId){
            key=data?.detail?.testApiId
          }
         
          this.callRazorPay(key,amount,order_id,currency)
          
        }
        else{
        this.callRazorPay(key,amount,order_id,currency)
        }
        
      }
      else{
        this.callRazorPay(key,amount,order_id,currency)
        }
    }, (error) => {
      this.callRazorPay(key,amount,order_id,currency)
    }, () => {
    });
  }

  callRazorPay(key,amount,order_id,currency) {
    var options = {
      key: key,
      amount: amount,
      description: 'Book Appointment',
      image: 'https://i.imgur.com/3g7nmJC.jpg',
      order_id: order_id,
      currency: currency,
      name: this.loginPatient?.firstname,
      handler: this.saveAppBooking.bind(this), 
    //function (response: any) {
      //   
      //   this.payment = 'paid';
      //   this.isAppointmentSaved = true;
      //   this.openLoginPopup = false;
       
      //   // let det = {
      //   //   DoctorId: 'this.doctorId',
      //   //   Date: 'this.slotDate',
      //   //   Duration: 'this.duration',
      //   //   PatientName: "this.patientDetails[0].firstname + (this.patientDetails[0].lastname ? ' ' + this.patientDetails[0].lastname : '')",
      //   //   PatientGender: "this.patientDetails[0].gender ? this.patientDetails[0].gender : ''",
      //   //   // PatientMobileNo: this.patientDetails[0].mobile,
      //   //   // patientDOB: this.patientDetails[0].dob,
      //   //   // Type: this.clinicType,
      //   //   // regId: this.patientDetails[0].id
      //   // }
      //   // this.phySrvc?.create(`bookingPlatform/bookPatientAppointment`, det)?.pipe(takeUntil(this?.unsubscribe$))?.subscribe(appDet => {
      //   //   
      //   //   this.appointmentDetails = appDet;
      //   //  })

      //   // alert(response.razorpay_payment_id);
      //   // alert(response.razorpay_order_id);
      //   // alert(response.razorpay_signature);

      //   // // after success response  call api verifypaymentsignature
      //   // 
      //   // let signaturedata = {
      //   //   "razorpay_order_id": response.razorpay_order_id,
      //   //   "razorpay_payment_id": response.razorpay_payment_id,
      //   //   "razorpay_signature": response.razorpay_signature
      //   // }
      //   // this.api.verifypaymentsignature(signaturedata, this.accessToken).subscribe(async (data1: any) => {
      //   //   console.log(data1);

      //   // }, async (err) => {
      //   //   if (err.error.text === "Success") {
      //   //     this.payment = 'paid';
      //   //     this.isAppointmentSaved = true;
      //   //     this.openLoginPopup = false;
      //   //     this.saveAppBooking();
      //   //   }
      //   //   else {
      //   //     this.isAppointmentSaved = false;
      //   //   }
      //   // })
      // },
      // callback_url: "https://eneqd3r9zrjok.x.pipedream.net/",
      modal: {
        escape: false,
      },
      prefill: {
        email: '',
        contact:  this.loginPatient?.mobile,
      },
      "theme": {
        "color": "#3399cc"
      }
    };
    
    var rzp1 = new Razorpay(options);
    rzp1.on('payment.failed', function (response) {
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
      this.payment = 'Notpaid';
      this.isAppointmentSaved = false;
      
    });
    document.getElementById('rzp-button1').onclick = function (e) {
      rzp1.open();
      e.preventDefault();
    }
  }

  onCountryCodeChange(code , type) {
  if(type=='Mobile'){
      this.mobileMinlength = code[0]?.data?.minMobileNumberLength ;
      this.mobileMaxlength = code[0]?.data?.maxMobileNumberLength ;
      this.bookingPlatFormApp.get('mobile').setValidators([Validators.minLength(this.mobileMinlength) , Validators.maxLength(this.mobileMaxlength)]);
      this.bookingPlatFormApp.get('mobile').updateValueAndValidity(); 
  }}
  
    async paynow() {
       //'rzp_live_br37R848nUFkMb'
      const options = {
        key: 'rzp_live_br37R848nUFkMb',
        amount:this.orderiddetails[0].amount,
        description: 'Book Appointment',
        image: 'https://i.imgur.com/3g7nmJC.jpg',
        order_id: this.orderiddetails[0].order_id,//Order ID generated in Step 1
        currency: this.orderiddetails[0].currency,
        name: this.username,
        prefill: {
          email: '',
          contact: this.mobilenum
        },
        theme: {
          color: '#852677;'
        }
      }
      try {
        let data = null;
        let sample =JSON.stringify(data);
        let nextsample = JSON.parse(sample)
        this.orderid =nextsample.response.razorpay_order_id;
        let signaturedata={
          "razorpay_order_id": nextsample.response.razorpay_order_id,
          "razorpay_payment_id": nextsample.response.razorpay_payment_id,
          "razorpay_signature": nextsample.response.razorpay_signature
      }
        this.api.verifyPaymentSignature(signaturedata,environment.virtualTenant,environment.virtualBranch).subscribe(async (data1:any) => {
          // console.log(data1);
          
        }, async (err) => {
          if(err.error.text === "Success"){
            this.payment ='paid';
            this.isAppointmentSaved = true;
            this.openLoginPopup = false;
          }
          else{
            this.isAppointmentSaved = false;
          }
        })
    
      } catch (error) {
        //it's paramount that you parse the data into a JSONObject
        let errorObj = JSON.parse(error['code'])
      }
  
    }

    onChangeDateTime() {
    this.changeTime.emit();
  }

  onClickSignUp(){
    this.tabsetEl.selectTab(this.register);
  }
  


  loadCountryMaster(): void {
    this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryCodeDropDownLists = data.details.filter(x => x.countryCode != null);
      
    }, (error) => {
      if(error.status==401){
        this.router.navigateByUrl('/auth/patient-portal');
      }
    }, () => {
      // this.signUp = true;
      this.bookingPlatFormApp.reset();
      this.invalidbookingPlatFormAppForm = false;
        const countryCode = this.countryCodeDropDownLists.filter(x => x.countryCode == this.countryCode);
        if(countryCode.length>0){
          this.mobileMinlength = countryCode[0]?.minMobileNumberLength ;
          this.mobileMaxlength = countryCode[0]?.maxMobileNumberLength ;
          this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
          this.loginForm.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
          localStorage.setItem('selectedCountryId',countryCode[0]?.id)
        }
    });
  }

  openLogin(){
    this.signUp=false;
    this.isSubmitted=false;
    this.loginForm.get('fullName').reset();
    this.loginForm.get('password').reset();
  }

  getTenantByCountryCode(){
    this.phySrvc.list(`${this.apiUrl}/tenants/${environment.virtualTenant}/tenantbranch/getSuperAdminByCountry?CountryCode=${this.countryCode}`).subscribe(data => {
      if(data.details){
        this.superAdminTenant = data.details
      }

    },(error)=>{if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal') },()=>{})
  }

    checksmspossibility(option){
      this.getTenantByCountryCode()
      let templateData;
      let istemplatepurchase;
      let patientDetails = {name: this.userName, mobileNumber: this.userMobileNumber, countryCode:this.countryCode, regId:'', email:this.patientEmail}
      this.rolesService.list(`PaymentGatewayConfiguration/GetCommDetByTemplateNamePatientportal?virtualTenantId=${environment.virtualTenant}&virtualBranchId=${environment.virtualBranch}&templateName=${this.pageName + '-' + option}&countryCode=${this.countryCode}`).subscribe((data:any) => {
        if(!!data?.details){
            istemplatepurchase = data?.details
          if(istemplatepurchase.smsFlag){
              if(istemplatepurchase.smsContent){   
                this.smscontent='Dear Nandhini, Your registration with our hospital on 15-oct has been successfully completed. Your registration no is 1234 Call us at 785878878787 to make appointments or for any other assistance. Regards, Team Ezovion'  
                                       
                // this.smscontent=istemplatepurchase.smsContent.replace((new RegExp("{patientname}", "g")),`${this.userName}`)
                // .replace((new RegExp("{hospitalphonenumber}", "g")),'')
                // .replace((new RegExp("{hospitalname}", "g")),'')
                // .replace((new RegExp("{regdate}", "g")),'')
                // .replace((new RegExp("{regno}", "g")),'')
  
                // .replace((new RegExp("{hospitalbranch}", "g")), '') 
                // .replace((new RegExp("{hospitalemailid}", "g")), '') 
                // .replace((new RegExp("{hospitalemail}", "g")), '') 
                // .replace((new RegExp("{currency}", "g")), '')    
                // .replace((new RegExp("{hospitalphonenumber}", "g")),'')
              }
                if(istemplatepurchase.creditBalance > 0){
                  this.sendSMS(patientDetails,istemplatepurchase,option);
                }else{
                  this.toaster.ForDanger('SMS Credit Balance is 0');
                }
          }
  
        if (istemplatepurchase.whatsappFlag) {
  
            if(istemplatepurchase?.whatsappContent){
                const matches = istemplatepurchase?.whatsappContent?.match(/{.*?}/g)?.join(" , ") || [];
                this.whatsappcontent='Dear Nandhini, Your registration on 15-oct has been successfully completed. Your registration no is 1234. Call us at 000409089 to make appointments or for any other assistance. Regards, Ezovion Team'
                // this. whatsappcontent = istemplatepurchase?.whatsappContent.replace((new RegExp("{patientname}", "g")),`${this.userName}`)
                // .replace((new RegExp("{hospitalphonenumber}", "g")),'')
                // .replace((new RegExp("{hospitalname}", "g")),'')
                // .replace((new RegExp("{regdate}", "g")),'')
                // .replace((new RegExp("{regno}", "g")),'')
  
                // .replace((new RegExp("{hospitalbranch}", "g")), '') 
                // .replace((new RegExp("{hospitalemailid}", "g")), '') 
                // .replace((new RegExp("{hospitalemail}", "g")), '') 
                // .replace((new RegExp("{currency}", "g")), '')    
                // .replace((new RegExp("{hospitalphonenumber}", "g")),'')
  
                const WithoutReplace = matches?.replace((new RegExp("{patientname}", "g")),`${this.userName}`)
                .replace((new RegExp("{hospitalphonenumber}", "g")),'000409089')
                .replace((new RegExp("{hospitalname}", "g")),'Ezovion')
                .replace((new RegExp("{regdate}", "g")),'15 oct')
                .replace((new RegExp("{regno}", "g")),'1234')
  
                .replace((new RegExp("{hospitalbranch}", "g")), 'chennai') 
                .replace((new RegExp("{hospitalemailid}", "g")), 'ezovion@gmail.com') 
                .replace((new RegExp("{hospitalemail}", "g")), 'ezovion@gmail.com') 
                .replace((new RegExp("{currency}", "g")), 'INR')    
                const placeholders = WithoutReplace?.split(",")?.map(s => s.trim())?.map(s => ({ text: s })) || ""; 
  
                if(istemplatepurchase?.whatsappCreditBalance > 0){
  
                  this.whatsAppToken = istemplatepurchase?.businessAppTokenNo
                  this.whatsAppUrl = istemplatepurchase?.whatsappApiUrl
                  
                  const whatsappSentItems = {
                    
                    phone : this.countryCode.replace(/\+/g, "") + this.userMobileNumber, 
                    templateName : istemplatepurchase?.whatsappTemplateName || '',
                    parameters : placeholders,
                    languageCode : istemplatepurchase?.whatsappTemplateLan
  
                  }
  
                  if(whatsappSentItems.phone && whatsappSentItems.templateName && whatsappSentItems.parameters && this.whatsAppToken && this.whatsAppUrl){
                    this.whatsappService.sendMessage(whatsappSentItems , this.whatsAppToken , this.whatsAppUrl).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                      if(data){
                          const whatsAppPostData = {
                            "branchId":this.superAdminTenant.branchId,
                            "tenantId":this.superAdminTenant.tenantId,
                            "dateTime": new Date(),
                            // "createdby": parseInt(localStorage.getItem("userId")),
                            "mobileNumber": whatsappSentItems.phone,
                            // "referencenum": paticentDetails.regNum ?? 0,
                            "referencefrom":this.pageName + '-' + option,
                            "message": this.whatsappcontent,
                            "smsUnit":1,
                            "senderId":null,
                            "status":"Sent",
                            "templateId":null,
                            "createdIp":null,
                            "createddate": new Date(),
                            "whatsappReferenceId":data?.messages[0]?.id ?? ''
                          }
                          this.rolesService.create(`${this.apiUrl}/smstrackingdet/${environment.virtualTenant}/${environment.virtualBranch}/sendWhatsapp`,whatsAppPostData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                            this.toaster.ForSuccess('Whatsapp Message Send Sucessfully');
                          },(error)=>{if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')},()=>{})
                        }else{
                          this.toaster.ForDanger('Whatsapp Message Send Unsucessfull');
                        }
                        })
                      }else{
                        // istemplatepurchase = templateData.whatsApp.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet.templateName.toLocaleLowerCase() == this.pageName+'-'+option)
                        // if(istemplatepurchase?.length>0){
                        //   if(templateData.whatsApp.smsCreditCount>0 && istemplatepurchase.length-1>-1){
                            this.towhatsappnumber=patientDetails.mobileNumber;
                            this.dialogRef = this.dialogService.open(
                              this.whatsappDialog,
                              {
                                closeOnBackdropClick: false,
                                closeOnEsc: false
                              });
                        // }
                        // }
                      }                     
  
                }else{
                    this.toaster.ForDanger('Whatsapp Credit Balance is 0');
                }
            }       
        }      
        }
          if(istemplatepurchase.emailFlag && patientDetails.email){
              if(istemplatepurchase.emailContent){            
                this.emailcontent=istemplatepurchase.emailContent.replace((new RegExp("{patientname}", "g")),`this.userName :''}`)
                .replace((new RegExp("{hospitalphonenumber}", "g")),'')
                .replace((new RegExp("{hospitalname}", "g")),'')
                .replace((new RegExp("{regdate}", "g")),'')
                .replace((new RegExp("{regno}", "g")),'')
  
                .replace((new RegExp("{hospitalbranch}", "g")), '') 
                .replace((new RegExp("{hospitalemailid}", "g")), '') 
                .replace((new RegExp("{hospitalemail}", "g")), '') 
                .replace((new RegExp("{currency}", "g")), '')    
                .replace((new RegExp("{hospitalphonenumber}", "g")),'')
              }
      
                if(istemplatepurchase.emailCreditBalance > 0){
  
                  const loadData = {
                    "Content" : this.emailcontent , 
                    "isTemplate" : istemplatepurchase , 
                    "Branch" : {name:this.superAdminTenant.branchId} ,
                    "Patient" : patientDetails , 
                    "Provider" : istemplatepurchase?.emailProviderName ,
                    "Subject" : `Registration Email From Ezovion`,
                    "HtmlContact" : `<html><head><title></title></head><body><p>${this.emailcontent}</p></body></html>`
                     
                  }
                  if(patientDetails.email){                          
                 this.MailService.sendMailMessage(loadData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                  if(data.response_type === "success"){
  
                          const whatsAppPostData = 
                          {
                            "referenceFrom": this.pageName+'-'+option,
                            "referenceNum": patientDetails.regId ?? 0,
                            "createdDateTime": new Date(),
                            // "createdBy": parseInt(localStorage.getItem("userId")),
                            "receiverEmailId": patientDetails.email,
                            "emailMessage": this.emailcontent,
                            "emailUnit": 1,
                            "senderEmailId": istemplatepurchase.emailSenderMail,
                            "sentStatus": "Pending",
                            "tenantId": this.superAdminTenant.tenantId,
                            "branchId": this.superAdminTenant.branchId,
                            "emailConfigId": istemplatepurchase.emailConfigId
                          }
  
                          this.rolesService.create(`${this.apiUrl}/emailConfigMst/PostEmailTrackingDet`,whatsAppPostData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                      this.toaster.ForSuccess('Email Message Send sucessfull');                          
                          }, (error) => {
                          if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')
                        }, () => {
                        })                  
  
  
                  }else{
                    this.toaster.ForDanger('Email Message Send Unsucessfull');
                  }
                 })
                }
                }else{
                  this.toaster.ForDanger('Email Credit Balance is 0');
                }
          }
  
      }, (error) => {
        if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')
      }, () => {
      })
    
    
    }
  
      sendSMS(appointmentData, templateData, options) {
      let smstrackingDetails = {
        referencefrom: this.pageName+'-'+ options,
        referencenum: appointmentData.regId,
        mobileNumber: appointmentData.mobileNumber,
        dateTime: this.DatService.currentDate(),
        message: this.smscontent,
        smsUnit: 1,
        status: "ok",      
        senderId: templateData.smsServiceName,
        templateId: templateData.smsTemplateDetId,
        
        createdIp: null,
        // createdby: parseInt(localStorage.getItem("userId")),
        createddate: this.DatService.currentDate(),
        tenantId: this.superAdminTenant.tenantId,
        branchId: this.superAdminTenant.branchId
      }
  
      let smsContent = {
        text: this.smscontent,
        mobile: appointmentData.mobileNumber,
        tenantApiConfigId:templateData?.smsConfigId,
        commonSmsTempId:templateData.commonTempMstId,
        
        tenantId: this.superAdminTenant.tenantId,
        branchId: this.superAdminTenant.branchId,
        smstrackingDetails: smstrackingDetails
      }
  
      this.rolesService.create(`${environment.apiUrl}/sms/send`, smsContent).subscribe(data => {
  
          if(data.code === 200){
            this.toaster.ForSuccess('SMS Send Sucessfully');
          }else{
            this.toaster.ForDanger('SMS Send Unsucessfull');
          }
  
      }, (error) => {
        this.toaster.ForDanger('SMS Send Unsucessfull');
        if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')
      }, () => {
      });
    }

  toLowerCase(event: any) {
    event.target.value = event.target.value.toLowerCase();
  } 

}
